// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__nbDXA","is-destructive":"Button_is-destructive__NVEc9","is-secondary":"Button_is-secondary__V4ejW","disabled":"Button_disabled__y2Ed8"};